/** Ported from haulsheet index.html ocrParseBME (Bennett / BME single load page). */
import { ocrBennettDim, ocrBlankLoad, ocrNum, ocrTitle, } from "./shared.js";
export function ocrParseBME(lines) {
    const text = lines.map((l) => l.text).join("\n");
    if (!/Load Number/i.test(text) || !/Trailer Type|Shipper Name/i.test(text))
        return [];
    const L = ocrBlankLoad();
    function g(re, n) {
        const m = text.match(re);
        return m ? String(m[n || 1]).trim() : "";
    }
    function all(re) {
        const out = [];
        let m;
        while ((m = re.exec(text)))
            out.push(m);
        return out;
    }
    const cities = all(/City:\s*(.+?)\s+State:\s*([A-Za-z]{2})\b/g);
    const zips = all(/Zip:\s*(\d{5})/g);
    const shipper = g(/Shipper Name:\s*(.+?)\s+Address:/);
    const shipAddr = g(/Shipper Name:.*?Address:\s*(.*)/);
    const cons = g(/onsignee Name:\s*(.+?)\s+Address:/);
    function placeOf(n, name, addr) {
        const c = cities[n];
        if (!c)
            return "";
        return (ocrTitle(c[1]) +
            ", " +
            c[2].toUpperCase() +
            (zips[n] ? " " + zips[n][1] : "") +
            (name ? " (" + ocrTitle(name) + (addr ? ", " + ocrTitle(addr) : "") + ")" : ""));
    }
    L.origin = placeOf(0, shipper, shipAddr);
    L.destination = placeOf(1, cons, "");
    if (cities.length < 2)
        L.unreadable.push("Could not read both the shipper and consignee city");
    const loadNo = g(/Load Number:\s*(\d+)/);
    const bol = g(/Customer BOL:\s*(\S+)/);
    const term = g(/Terminal:\s*(\S+)/);
    L.ref =
        "Bennett load " +
            (loadNo || "?") +
            (bol ? ", customer BOL " + bol : "") +
            (term ? ", agent terminal " + term.toUpperCase() : "");
    const tt = g(/Trailer Type:\s*(\S+)/);
    L.equipment = tt
        ? tt.toUpperCase() === "D"
            ? "Drop deck (trailer type D)"
            : tt.toUpperCase() === "F"
                ? "Flatbed (trailer type F)"
                : "Trailer type " + tt
        : "";
    if (tt)
        L.unreadable.push('Trailer type shows only the code "' + tt + '": confirm what it means');
    L.commodity = ocrTitle(g(/Commodity:\s*(.+)/));
    L.pieces = g(/Pieces:\s*0*(\d+)/);
    L.weight = ocrNum(g(/Weight:\s*([\d,]+)/));
    L.length = ocrBennettDim(g(/Length:\s*([\d.]+)/), "Length", L);
    L.width = ocrBennettDim(g(/Width:\s*([\d.]+)/), "Width", L);
    L.height = ocrBennettDim(g(/Height:\s*([\d.]+)/), "Height", L);
    const ld = g(/Load Date:\s*(\d\d\/\d\d\/\d\d)/);
    const dd = g(/Delivery Date:\s*(\d\d\/\d\d\/\d\d)/);
    const times = all(/(\d{4})\s*\(hhmm\)/g);
    function iso(d, t) {
        return d && t
            ? "20" + d.slice(6) + "-" + d.slice(0, 2) + "-" + d.slice(3, 5) + "T" + t.slice(0, 2) + ":" + t.slice(2)
            : "";
    }
    const lt = times[0] ? times[0][1] : "";
    const dt = times[1] ? times[1][1] : "";
    L.pickup = ld + (lt ? ", no later than " + lt.slice(0, 2) + ":" + lt.slice(2) : "");
    L.delivery = dd + (dt ? ", no later than " + dt.slice(0, 2) + ":" + dt.slice(2) : "");
    L.pickupAt = iso(ld, lt);
    L.deliverBy = iso(dd, dt);
    const tarps = g(/Tarps:\s*([YN])\b/);
    L.tarp = tarps ? (tarps === "Y" ? "Yes (Tarps: Y)" : "No (Tarps: N)") : "";
    L.miles = ocrNum(g(/Miles:\s*([\d,]+)/));
    const notes = [];
    [
        ["Broker Load", /Broker Load:\s*([YN])\b/],
        ["Stop offs", /Stop Offs:\s*([YN])\b/],
        ["Riggers", /Riggers:\s*([YN])\b/],
        ["Special instructions", /Special Instructions:\s*([YN])\b/],
    ].forEach((p) => {
        const x = g(p[1]);
        if (x)
            notes.push(p[0] + ": " + x);
    });
    const exp = g(/Expiration Date:\s*(\d\d\/\d\d\/\d\d)/);
    if (exp)
        notes.push("Order expires " + exp);
    L.notes = notes.join(". ") + (notes.length ? "." : "");
    L.unreadable.push("No rate on this screen: enter one to see the money");
    L.unreadable.push("Sizes are read the Bennett way, as feet.inches (8.06 = 8 ft 6 in)");
    if (/Special Instructions:\s*Y/.test(text)) {
        L.unreadable.push("Special instructions are marked Y but the text is not on this screen");
    }
    return [L];
}
//# sourceMappingURL=bme.js.map